import React from 'react';
import GanttStore from '../../../stores/gantt/GanttStore';
import { observer } from 'mobx-react';
import { Modal, Button } from 'antd';

@observer
export default class DeleteConfirmDialog extends React.Component<{ ganttStore: GanttStore }, any>{
    render() {
        const { ganttStore } = this.props;
        return <div>
            <Modal ecId={`${this && this.props && this.props.ecId || ''}_Modal@w7k6dw`} wrapClassName="deleteConfirmDialog" style={{width:'400px',height:'300px'}} visible={ganttStore.deletevisible}
                maskClosable={false}
                title={<span><i className="icon-coms-Prompt" style={{color: 'orange',
                    fontSize:'20px',marginRight: '10px',position:'relative',top: '4px'}}></i>删除确认</span>} onOk={() => { }} onCancel={() => { ganttStore.deletevisible = false }}
                footer={[
                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@mamvtz@deleteTaskRow1`} key="submit" type="primary" size="large" onClick={() => {ganttStore.deleteTaskRow(1)}}>是，且删除子级</Button>,
                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@2foc8p@deleteTaskRow0`} key="submit" type="primary" size="large" onClick={() => {ganttStore.deleteTaskRow(0)}}>是，不删除子级</Button>,
                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@wya63o@deletevisible`} key="back" type="ghost" size="large" onClick={() => { ganttStore.deletevisible = false }}>否</Button>,
                ]}
            >
                <p>&nbsp;</p>
                <p style={{fontSize:'14px',textAlign:'center'}}>确定删除吗？</p>
                <p>&nbsp;</p>
            </Modal>
        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/dialog/DeleteConfirmDialog.tsx